import { createApp } from 'vue';
import PefToWebpConverter from '../Components/PefToWebpConverter.vue';

const root = document.getElementById('pef-to-webp-converter');
if (root) {
  createApp(PefToWebpConverter).mount('#pef-to-webp-converter');
}
